var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M22.388 14.167h-6.956c-.699 0-1.265.566-1.265 1.265v6.87m23.445-8.135h6.956c.699 0 1.265.566 1.265 1.265v6.87m-23.445 23.53h-6.956a1.266 1.266 0 0 1-1.265-1.265v-6.87m23.445 8.135h6.956c.699 0 1.265-.566 1.265-1.265v-6.87m-4.576-.601V23.359c0-.699-.566-1.266-1.265-1.266H20.356c-.699 0-1.265.567-1.265 1.266v13.738c0 .699.566 1.265 1.265 1.265h19.636c.699 0 1.265-.566 1.265-1.265Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFull);
export default __webpack_public_path__ + "static/media/full.a2bad176beaa3b45e62d6ac6fc9d2e3d.svg";
export { ForwardRef as ReactComponent };